export interface TipoPersona {
    value: string;
    label: string;
  }
  
  export const TIPOS_PERSONA: TipoPersona[] = [
    { "value": "N", "label": "Natural" },
    { "value": "J", "label": "Jurídica" }
  ];